<template>
  <div
    class="detail_main">
    <div @click="$parent.show = false" class="detail_container"
     :class="{'bg_detail': bg}">
    </div>
      <section
        class="size_detail
          zero_right
          margin_top_detail
          padding_bottom_detail
          has-background-white
          is-scrollable">
        <div class="columns is-marginless detail_content detail_content_bg">
          <div class="half_width detail_img_info">
            <a
              class="button has-text-white is-rounded diapo_button"
              :class="{'is-primary': hoverButton}"
              @click="show = true"
              @mouseover.prevent="hoverButton = true"
              @mouseout.prevent="hoverButton = false">
              <span class="icon">
                <b-icon
                  icon="image-multiple"
                  size="is-small">
                </b-icon>
              </span>
              <p class="p_size14">Voir diaporama</p>
            </a>
            <img :src="url" class="imageBgOpp imgGoToTop">
          </div>
          <div class="half_width topVert leftVert rightVert">
            <a @click="$parent.show = false"
              class="detail_icon_close_right">
              <b-icon
                icon="window-close"
                size="">
              </b-icon>
            </a>
            <h3 class="has-text-weight-bold has-text-link bottomViolet">
              Proposition:</h3>
            <div class="columns is-marginless is-multiline color-icon detail_content_propo">
              <div
                v-if="detailResauxComplet.extensionOpportunite.duree"
                class="column bottomViolet is-paddingless is-6">
                <div class="media">
                  <b-icon
                    icon="timer"
                    size="is-medium"
                    class="media-left">
                  </b-icon>
                  <div class="media-content is-size-7">
                    <label class="has-text-default">
                      Durée
                    </label><br>
                    <p class="p_size14 has-text-weight-bold has-text-link">
                      {{detailResauxComplet.extensionOpportunite.duree}}
                    </p>
                  </div>
                </div>
              </div>
              <div
                v-if="detailResauxComplet.tarifBrut"
                class="column bottomViolet is-paddingless is-6">
                <div class="media">
                  <b-icon
                    icon="cash"
                    size="is-medium"
                    class="media-left">
                  </b-icon>
                  <div class="media-content is-size-7">
                    <label class="has-text-default">
                      Tarif Brut HT
                    </label><br>
                    <p class="p_size14 has-text-weight-bold has-text-link">
                      {{tarif(detailResauxComplet.tarifBrut)}}
                      {{this.detailResauxComplet.extensionOpportunite.tarifInformation}}
                    </p>
                  </div>
                </div>
              </div>
              <div
                v-if="detailResauxComplet.extensionOpportunite.tarifNet"
                class="column bottomViolet is-paddingless is-6">
                <div class="media">
                  <b-icon
                    icon="cash"
                    size="is-medium"
                    class="media-left">
                  </b-icon>
                  <div class="media-content is-size-7">
                    <label class="has-text-default">
                      Tarif Net HT
                    </label><br>
                    <p class="p_size14 has-text-weight-bold has-text-link">
                      {{tarif(detailResauxComplet.extensionOpportunite.tarifNet)}}
                      {{this.detailResauxComplet.extensionOpportunite.tarifInformation}}
                    </p>
                    <span class="has-text-grey is-italic"
                      v-if="detailResauxComplet.extensionOpportunite.masquerRemiseEdition === true
                        && this.detailResauxComplet.extensionOpportunite.remise">
                      {{this.detailResauxComplet.extensionOpportunite.remise}} {{typeRemise}}
                    </span>
                  </div>
                </div>
              </div>
              <div
                v-if="detailResauxComplet.extensionOpportunite.fraisTechnique"
                class="column bottomViolet is-paddingless is-6">
                <div class="media">
                  <b-icon
                    icon="panorama-wide-angle"
                    size="is-medium"
                    class="media-left">
                  </b-icon>
                  <div class="media-content is-size-7">
                    <label class="has-text-default">
                      Frais techniques HT
                    </label><br>
                    <p class="p_size14 has-text-weight-bold has-text-link">
                      {{tarif(detailResauxComplet.extensionOpportunite.fraisTechnique)}}
                    </p>
                  </div>
                </div>
              </div>
              <div
                v-if="detailResauxComplet.extensionOpportunite.tarifDePose"
                class="column bottomViolet is-paddingless is-6">
                <div class="media">
                  <b-icon
                    icon="sign-text"
                    size="is-medium"
                    class="media-left">
                  </b-icon>
                  <div class="media-content is-size-7">
                    <label class="has-text-default">
                      Frais de pose HT
                    </label><br>
                    <p class="p_size14 has-text-weight-bold has-text-link">
                      {{tarif(detailResauxComplet.extensionOpportunite.tarifDePose)}}
                    </p>
                  </div>
                </div>
              </div>
              <div
                v-if="detailResauxComplet.extensionOpportunite.taxeMunicipale"
                class="column bottomViolet is-paddingless is-6">
                <div class="media">
                  <b-icon
                    icon="ballot"
                    size="is-medium"
                    class="media-left">
                  </b-icon>
                  <div class="media-content is-size-7">
                    <label class="has-text-default">
                      Taxes municipales
                    </label><br>
                    <p class="p_size14 has-text-weight-bold has-text-link">
                      {{tarif(detailResauxComplet.extensionOpportunite.taxeMunicipale)}}
                    </p>
                  </div>
                </div>
              </div>
              <div
                v-if="detailResauxComplet.extensionOpportunite.date"
                class="column bottomViolet is-paddingless is-6">
                <div class="media">
                  <b-icon
                    icon="calendar"
                    size="is-medium"
                    class="media-left">
                  </b-icon>
                  <div class="media-content is-size-7">
                    <label class="has-text-default">
                      Disponible le
                    </label><br>
                    <p class="p_size14 has-text-weight-bold has-text-link">
                      {{detailResauxComplet.extensionOpportunite.date}}
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div v-if="detailResauxComplet.extensionOpportunite.commentaire">
              <h3 class="has-text-weight-bold topViolet has-text-link">
                Commentaire:</h3>
              <div class="">
                <p class="has-text-link has-text-justify p_size14 mb-btnaction">
                  {{detailResauxComplet.extensionOpportunite.commentaire}}
                </p>
              </div>
            </div>
          </div>
        </div>
        <div class="columns is-marginless is-block detail_content">
          <div class="column leftVert topViolet rightVert is-paddingless">
            <h3 class="has-text-weight-bold bottomVert has-text-link">
              Caractéristiques:</h3>
            <p class="is-size-7 bottomViolet">
              <label class="has-text-default">
                Nom du réseau
              </label><br>
              <strong class="p_size14 has-text-link">
                {{detailResauxComplet.libelle}}
              </strong>
            </p>
            <div class="columns is-multiline color-icon">
              <div class="column">
                <div class="media">
                  <b-icon
                    icon="city"
                    size="is-medium"
                    class="media-left">
                  </b-icon>
                  <div class="media-content is-size-7">
                    <label class="has-text-default">
                      Ville
                    </label><br>
                    <p class="p_size14 has-text-weight-bold has-text-link">
                      {{detailResauxComplet.ville}}
                    </p>
                  </div>
                </div>
              </div>
              <div class="column">
                <div class="media">
                  <b-icon
                    icon="vector-intersection"
                    size="is-medium"
                    class="media-left">
                  </b-icon>
                  <div class="media-content is-size-7">
                    <label class="has-text-default">
                      Format
                    </label><br>
                    <p class="p_size14 has-text-weight-bold has-text-link">
                      {{detailResauxComplet.format}}
                    </p>
                  </div>
                </div>
              </div>
              <div class="column" v-if="detailResauxComplet.nbFaces">
                <div class="media">
                  <b-icon
                    icon="sign-text"
                    size="is-medium"
                    class="media-left">
                  </b-icon>
                  <div class="media-content is-size-7">
                    <label class="has-text-default">
                      Nombre de faces
                    </label><br>
                    <p class="p_size14 has-text-weight-bold has-text-link">
                      {{detailResauxComplet.nbFaces}}
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div class="column topRouge bottomVert is-4 is-offset-8">
              <div v-if="!detailResauxComplet.select" @click="contolSelect()">
                <a class="button is-primary is-rounded t14 topVert rightVert">
                  Ajouter à ma sélection
                </a>
              </div>
              <div v-else @click="contolSelect()">
                <a class="button has-text-white boutonRed is-rounded t14 topVert rightVert">
                  Retire de ma sélection
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>
    <transition
      name="custom-classes-transition"
      enter-active-class="animated fadeIn"
      leave-active-class="animated fadeOut"
      :duration="1000">
      <app-diapo-reseaux-lc
        :detailReseauxLc="detailResauxComplet.listeFaces"
        :reseau="detailResauxComplet.libelle"
        v-if="show"/>
    </transition>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import { urlPhoto, formatNum } from '@/services/opportunite/formatTab';
import diapoReseauxLc from './diapoReseauxLc';

export default {
  name: 'detailReseauxLcCompletDiapo',
  props: ['detailResauxComplet', 'bg'],
  data() {
    return {
      show: false,
      hoverButton: false,
    };
  },
  components: {
    appDiapoReseauxLc: diapoReseauxLc,
  },
  computed: {
    url() {
      return urlPhoto(this.detailResauxComplet.urlPhoto);
    },
    typeRemise() {
      if (this.detailResauxComplet.extensionOpportunite.typeDeRemise === 0) {
        return '% de remise inclus';
      }
      return '€ de remise inclus';
    },
    getTarif() {
      let tarifNet = 0;
      let tarifDePose = 0;
      let taxeMunicipale = 0;
      let fraisTechnique = 0;
      let tarifBrut = 0;
      if (this.detailResauxComplet.extensionOpportunite.tarifDePose) {
        tarifDePose = this.detailResauxComplet.extensionOpportunite.tarifDePose;
      }
      if (this.detailResauxComplet.extensionOpportunite.taxeMunicipale) {
        taxeMunicipale = this.detailResauxComplet.extensionOpportunite.taxeMunicipale;
      }
      if (this.detailResauxComplet.extensionOpportunite.fraisTechnique) {
        fraisTechnique = this.detailResauxComplet.extensionOpportunite.fraisTechnique;
      }
      if (this.detailResauxComplet.extensionOpportunite.tarifBrut) {
        tarifBrut = this.detailResauxComplet.extensionOpportunite.tarifBrut;
      }
      if (this.detailResauxComplet.extensionOpportunite.tarifNet) {
        tarifNet = this.detailResauxComplet.extensionOpportunite.tarifNet;
        return tarifNet
        + tarifDePose
        + taxeMunicipale
        + fraisTechnique;
      }
      return tarifBrut
        + tarifDePose
        + taxeMunicipale
        + fraisTechnique;
    },
  },
  methods: {
    ...mapActions([
      'add',
      'substract',
      'addNbSelect',
      'substractNbSelect',
    ]),
    contolSelect() {
      this.detailResauxComplet.select = !this.detailResauxComplet.select;
      if (this.detailResauxComplet.select) {
        this.add(this.getTarif);
        this.addNbSelect();
      } else {
        this.substract(this.getTarif);
        this.substractNbSelect();
      }
    },
    tarif(t) {
      return formatNum(t);
    },
    close() {
      this.$parent.show = false;
    },
  },
  mounted() {
    const test = document.querySelector('html');
    test.style.overflow = 'hidden';
  },
  destroyed() {
    const test = document.querySelector('html');
    test.style.overflow = '';
  },
};
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/opportuniteClient/propositions/reseauxLc/detailReseauxLcCompletDiapo.vue